import $ from 'jquery';


let filters = {

    filters_form : $('#shop-filters'),
    products : $('ul.products'),
    pagination : $('.pagination'),
    clear : $('#clear-filters'),

    init(){
        //this.changeFilter();
        if( !$('#shop-filters').length ){ return; }

        this.filters_form.change((e) => {
            $('input#pageNo').val(1);
            this.changeFilter();
        })

        this.pagination.find('#load-more').click((e) => {
            e.preventDefault();
            var current_page = this.filters_form.find('input#pageNo').val();
            $('input#pageNo').val(++current_page);
            this.changeFilter(1);            
        })

        this.clear.click((e) => {
            e.preventDefault();
            this.filters_form.find("input:checkbox").prop("checked", false);
            this.changeFilter();
        })

        $('.toggle-filters').click((e) => {
            e.preventDefault();
            $('.sidebar').slideToggle();
            $(e.currentTarget).find('.open').toggle();
            $(e.currentTarget).find('.close').toggle();
        })
    },

    changeFilter( $more = 0 ){
        var current_lang = $('html').attr('lang');
        this.filters_form.find('input#language').val(current_lang);
        
        var data = this.filters_form.serialize();
        console.log(data);

        $.ajax({
            type : 'post',
            url : myAjax.ajaxurl,
            //dataType: 'json',
            data : data,
            beforeSend: () => {
                this.products.hide();
                $('.lds-roller').addClass('show');
            },
            success: (response) => {
                if( $more ){
                    this.products.append(response);                    
                }else{
                    this.products.html(response);
                }
                this.products.show();
                if( !response  ){
                    this.pagination.find('#load-more').html("THATS ALL");
                    this.pagination.find('#load-more').css('pointer-events','none');
                }else{
                    this.pagination.find('#load-more').html("LOAD MORE");
                    this.pagination.find('#load-more').css('pointer-events','unset');    
                }
                $('.lds-roller').removeClass('show');
            }
        })
    },



}
export default filters;